<template>
  <section class="components-app-searsh">
    <div class="show-box-search pointer" @click="isSearch = !isSearch">
      <i class="flaticon-loupe icon-35" v-if="!isSearch"></i>
      <i class="flaticon-remove icon-35" v-else></i>
    </div>
    <div class="search-site" v-if="isSearch">
      <div class="group-form">
        <input v-focus type="search" :class="{active:search != ''}" v-model="search">
        <span class="bar"></span>
        <label>{{ $t('label.searsh')}}</label>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "app-search",
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  data() {
    return {
      search: "",
      isSearch: false
    };
  }
};
</script>

<style lang="less">
@import (reference) "../../../assets/css/variable.less";
.components-app-searsh {
  .show-box-search {
    i {
      transform: scale(1.2);
      position: relative;
    }
  }
  .search-site {
    position: fixed;
    right: 0;
    left: 0;
    top: 60px;
    margin: auto;

    .group-form {
      margin-bottom: 0;
      -webkit-box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.2);
      -moz-box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.2);
      box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.2);
      input {
        padding-left: 25px;
        border-bottom: none;
        background: #fff;
      }
      label {
        margin-left: 20px;
        text-transform: capitalize;
      }
      input.active ~ label,
      input:focus ~ label {
        top: 0;
        font-size: 14px;
        color: @textPrimaryColor;
        transform: scale(0);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/search/index.vue